const KEY = "stock_theme";

export function getStoredTheme() {
    try {
        return localStorage.getItem(KEY) || "light";
    } catch { return "light"; }
}

export function applyTheme(theme) {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    try { localStorage.setItem(KEY, theme); } catch {}
}

export function initTheme() {
    applyTheme(getStoredTheme());
}
